<template>
  <v-container>
    <TitleParagraphRow :value="value" />

    <v-row v-if="value.items && value.items.length">
      <v-col v-for="item in value.items" :key="item.id" cols="12" md="3">
        <v-card color="transparent" variant="flat">
          <v-card-item v-if="item.icon" class="text-center">
            <v-icon
              v-if="typeof item.icon === 'string'"
              :color="item.color || 'grey-darken-2'"
              :icon="`hdf:${item.icon}`"
              :size="item.content ? 90 : 150"
            />
          </v-card-item>

          <v-card-item v-if="item.title" class="text-h5 text-center">
            <StyledText :value="item.title" />
          </v-card-item>

          <v-card-text
            v-if="item.content"
            class="text-body-0 text-center"
            style="line-height: 150%"
          >
            <ContentBlock
              :value="item.content"
              em-class="text-decoration-underline"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
